// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import less from 'less'
import '@/assets/css/reset.css'
import "@/assets/css/element.less"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import ComHeader from "@/components/ComHeader";
import ComCard from "@/components/ComCard";
import resLoader from '@/utils/resLoader'

import { post, get, deleteFun, put } from "@/utils/request.js";

Vue.use(router)
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$deleteFun = deleteFun;
Vue.prototype.$put = put;
Vue.prototype.$resLoader = resLoader;
Vue.component('com-header',ComHeader)
Vue.component('com-card',ComCard)

Vue.use(less)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js